<template>
  <div class="login-box">
    <h2 class="login-box__header">用户登录</h2>
    <el-form class="login-form" ref="form" :model="form">
      <el-form-item>
        <el-input
          v-model="form.username"
          placeholder="请输入用户名"
          @keypress.native.enter="onLogin"
        >
          <i slot="prefix" class="login-form__prefix account-prefix"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="form.password"
          type="password"
          placeholder="请输入密码"
          @keypress.native.enter="onLogin"
        >
          <i slot="prefix" class="login-form__prefix password-prefix"></i>
        </el-input>
      </el-form-item>
      <!-- 登录 & 注册 -->
      <div class="btns">
        <el-button
          class="login-box-btn login-btn"
          type="primary"
          @click="onLogin"
          >登录</el-button
        >
        <el-button
          plain
          class="register-box-btn register-btn"
          @click="onRegister"
          >注册</el-button
        >
        <el-button
          class="forget-box-btn forget-btn"
          type="text"
          @click="onForget"
          >忘记密码？</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'LoginBox',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {},
    }
  },
  watch: {
    data(newVal) {
      this.form = newVal || {}
    },
  },
  computed: {},
  async mounted() {},
  methods: {
    onLogin() {
      this.$emit('submit', this.form)
    },
    onRegister() {
      this.$emit('onRegister')
    },
    onForget() {
      this.$emit('onForget')
    },
  },
}
</script>

<style lang="scss" scoped>
.login-box {
  position: relative;
  width: val(460);
  padding: val(53) val(31) val(71) val(33);
  background-color: #ffffff;
  z-index: 1;
  box-shadow: 0px val(4) val(21) rgba(75, 19, 1, 0.16);
  border-radius: val(15);
  &__header {
    color: #202020;
    font-size: val(24);
    text-align: center;
    margin-bottom: val(54);
  }
}
.login-form {
  ::v-deep {
    .el-form-item {
      margin-bottom: val(17);
      &__content {
        line-height: val(50);
      }
    }

    .el-input {
      &__prefix {
        display: flex;
        align-items: center;
        left: val(15);
      }
      &__inner {
        height: val(50);
        font-size: val(14);
        line-height: 0;
        &::placeholder {
          color: #8c8c8c;
        }
        &:focus {
          border-color: #3798dc;
          box-shadow: 0px 0px val(3) rgba(55, 152, 220, 0.28);
        }
      }
      &--prefix {
        &:before {
          content: '';
          position: absolute;
          left: val(55);
          top: 50%;
          width: val(1);
          height: val(24);
          transform: translateY(-50%);
          background-color: #e5e5e5;
        }
        .el-input__inner {
          padding-left: val(71);
          border-color: #e5e5e5;
        }
      }
    }
  }
  &__prefix {
    &.account-prefix {
      width: val(27);
      height: val(27);
      background: url('../../../../assets/images/account.png');
      background-size: 100% 100%;
    }
    &.password-prefix {
      width: val(27);
      height: val(27);
      background: url('../../../../assets/images/password.png');
      background-size: 100% 100%;
    }
  }
}

.btns {
  margin-top: val(47);
  .login-box-btn,
  .register-box-btn {
    position: relative;
    display: block;
    width: 100%;
    height: val(50);
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: val(18);
    border-radius: val(5);
    font-weight: normal;
    &.login-btn {
      background: #0077e8;
      margin-bottom: val(20);
    }
    &.register-btn {
      background-color: #fff;
      color: #0077e8;
      border: 1px solid #0077e8;
    }
  }
  .forget-box-btn {
    position: absolute;
    right: val(31);
    bottom: val(35);
    padding: 0;
    font-size: val(16);
    font-weight: normal;
  }
}
</style>
